import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const mobileMenuRef = useRef(null); // Reference for the mobile menu
  const menuButtonRef = useRef(null); // Reference for the hamburger button

  // Toggle the menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close the menu if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target) && !menuButtonRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="flex justify-between items-center p-5 text-white"
      style={{
        background: 'linear-gradient(135deg,rgb(247, 248, 249) 50%, #29313F 50%)',
        position: 'fixed',  // Fix the header at the top of the page
        top: '0',
        left: '0',
        right: '0',
        zIndex: '1000',  // Ensure the header stays on top of other elements
      }}
    >
<a href="/">
  <div className="logo">
    <img 
      src="/logo.png" 
      alt="Logo" 
      className="w-24"
    />
  </div>
</a>


      
      <div className="hidden lg:flex">
        {/* Desktop Navigation */}
        <nav>
          <ul className="flex list-none p-0 m-0">
            <li><Link to="/" className="text-white  mx-4 hover:text-gray-300" style={{ fontSize: '25px' }}>Home</Link></li>
           <li><Link to="/aboutus" className="text-white  mx-4 hover:text-gray-300" style={{ fontSize: '25px' }}>About Us</Link></li>
            <li><Link to="/commodities" className="text-white  mx-4 hover:text-gray-300" style={{ fontSize: '25px' }}>Commodities</Link></li>
            <li><Link to="/contactus" className="text-white   mx-4 hover:text-gray-300"style={{ fontSize: '25px' }}>Contact Us</Link></li>
            <li><Link to="/services" className="text-white mx-4 hover:text-gray-300"style={{ fontSize: '25px' }}>Services</Link></li>
          </ul>
        </nav>
      </div>

      {/* Hamburger Icon */}
      <div className="lg:hidden">
        <button ref={menuButtonRef} onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes className="text-white text-2xl" /> : <FaBars className="text-white text-2xl" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div ref={mobileMenuRef} className={`lg:hidden absolute top-0 right-0 w-2/3 h-50 bg-[#29313F] p-5 transform transition-transform duration-300 ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} style={{ borderRadius: '20px' }}>
        {/* Cancel Icon to close the menu */}
        <button onClick={toggleMenu} className="absolute top-4 right-4 text-white text-3xl">
          <FaTimes />
        </button>
        
        <nav>
          <ul className="flex flex-col list-none p-0 m-0 space-y-4">
            <li><Link to="/" className="text-white  font-bold hover:text-gray-300" onClick={toggleMenu} style={{ fontSize: '20px' }}>Home</Link></li>
           <li><Link to="/aboutus" className="text-white  font-bold hover:text-gray-300" onClick={toggleMenu} style={{ fontSize: '20px' }}>About Us</Link></li>
            <li><Link to="/commodities" className="text-white font-bold hover:text-gray-300" onClick={toggleMenu} style={{ fontSize: '20px' }}>Commodities</Link></li>
            <li><Link to="/contactus" className="text-white  font-bold hover:text-gray-300" onClick={toggleMenu} style={{ fontSize: '20px' }}>Contact Us</Link></li>
            <li><Link to="/services" className="text-white  font-bold hover:text-gray-300" onClick={toggleMenu} style={{ fontSize: '20px' }}>Services</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
